import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CalculateIcon from '@mui/icons-material/Calculate';
import { formatCurrency } from '../../utils/formatters';

// Reusable components
const SectionHeader = ({ title }) => (
  <Box display="flex" alignItems="center" mb={2}>
    <CalculateIcon color="primary" sx={{ mr: 1 }} />
    <Typography variant="h6">{title}</Typography>
  </Box>
);

const FinancialRow = ({ label, valueBRL, valueUSD }) => (
  <TableRow>
    <TableCell component="th" scope="row">
      {label}
    </TableCell>
    <TableCell align="right">{formatCurrency(valueBRL, 'BRL')}</TableCell>
    <TableCell align="right">{formatCurrency(valueUSD, 'USD')}</TableCell>
  </TableRow>
);

/**
 * ClientEntryInvoiceSection - Displays client entry invoice information
 * For Account and Order (Third Parties Import) order type
 * @param {Object} props - Component props
 * @param {Object} props.order - Order data
 */
const ClientEntryInvoiceSection = ({ order }) => {
  if (!order) return null;

  // Get tax calculation data from order
  const taxCalculation = order.latest_tax_calculation || {};

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <SectionHeader title="CLIENT ENTRY INVOICE" />
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell align="right">BRL</TableCell>
                <TableCell align="right">USD</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <FinancialRow
                label="ICMS Calculation Base"
                valueBRL={taxCalculation.base_calculo_conta_ordem_brl}
                valueUSD={taxCalculation.base_calculo_conta_ordem_usd}
              />
              <FinancialRow
                label="ICMS - Invoice Amount"
                valueBRL={taxCalculation.icms_destaque_nf_brl}
                valueUSD={taxCalculation.icms_destaque_nf_usd}
              />
              <FinancialRow
                label="IPI - Invoice Amount"
                valueBRL={taxCalculation.ipi_destaque_nf_brl}
                valueUSD={taxCalculation.ipi_destaque_nf_usd}
              />
              <FinancialRow
                label="ICMS Tax Substitution - Invoice Amount"
                valueBRL={taxCalculation.icms_st_destaque_nf_brl}
                valueUSD={taxCalculation.icms_st_destaque_nf_usd}
              />
              <TableRow sx={{ backgroundColor: 'rgba(0, 0, 0, 0.04)' }}>
                <TableCell component="th" scope="row">
                  <Typography fontWeight="bold">Invoice Total</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(taxCalculation.nota_fiscal_entrada_cliente_brl)}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(taxCalculation.nota_fiscal_entrada_cliente_usd, 'USD')}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default ClientEntryInvoiceSection;